<template>
  <div >{{ reason }}</div>
</template>
<script>
import commonMixin from "@/mixins/common";
import wsMixin from "@/modules/customerVbzWorksheet/wsMixin";

export default {
  name:'AbsenceDuration',
  mixins: [commonMixin,wsMixin],
  props: {
    absence:Object,
    isDisabled:{type:Boolean,default:false}
  },
  computed: {
    reason() {
      return this.mx_reason(this.absence);
    },
  },
}
</script>